import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    token: null,
    user: null,
    expires: null,
    incompleteLeads: { data: [] }
  },
  getters: {
    getToken(state) {
      return state.token;
    },
    getUser(state) {
      return state.user;
    },
    getExpires(state) {
      return state.expires;
    },
    getIncompleteLeads(state) {
      return state.incompleteLeads;
    }
  },
  mutations: {
    setExpires(state, payload) {
      let exp = null;
      if (!payload) {
        let now = new Date();
        exp = new Date(now.getTime() + 1 * 1000 * 60 * 60);
      } else {
        exp = payload * 1000;
      }
      state.expires = exp;
      localStorage.setItem("expires", exp);
    },
    setToken(state, payload) {
      state.token = payload;
      axios.defaults.headers.common["Authorization"] = "Bearer " + payload;
      localStorage.setItem("token", payload);
    },
    clearToken(state) {
      state.token = null;
      axios.defaults.headers.common["Authorization"] = "Bearer ";
      localStorage.removeItem("token");
    },
    clearExpires(state) {
      state.expires = null;
    },
    setUser(state, payload) {
      state.user = payload;
    },
    clearUser(state) {
      state.user = null;
    },
    setIncompleteLeads(state, payload) {
      state.incompleteLeads = payload;
      let p = JSON.stringify(state.incompleteLeads);
      localStorage.setItem("incompleteLeads", p);
    },
    clearIncompleteLeads(state) {
      state.incompleteLeads = { data: [] };
      localStorage.removeItem("incompleteLeads");
    },
    addIncompleteLead(state, payload) {
      state.incompleteLeads.data.push(payload);
      let p = JSON.stringify(state.incompleteLeads);
      localStorage.setItem("incompleteLeads", p);
    },
    removeIncompleteLead(state, payload) {
      state.incompleteLeads.data.splice(payload, 1);
      let p = JSON.stringify(state.incompleteLeads);
      localStorage.setItem("incompleteLeads", p);
    }
  },
  namespaced: true
});



// WEBPACK FOOTER //
// ./src/store.js